import axiosApi from '@/api/axiosApi';
import { IBillSplitInfo } from '@/models/billSplit';

const EXPENSE_SPLIT_API_URL = process.env.REACT_APP_EXPENSE_SPLIT_API_URL || 'expense-split-api-preprod';
export const splitBill = (data:IBillSplitInfo) => {
  return axiosApi.post(EXPENSE_SPLIT_API_URL, data);
};